import styled from "styled-components";

export const PureFormWrapperStyled = styled.div`
    margin-bottom: 20px;
`;